import { AppRouteProps } from "@mzara/component";
import React from "react";

const CvListContainer= React.lazy(()=>import('./containers/CvListContainer') )
export const CvListPublicationRoutes : Array <AppRouteProps>=[
    {
        path:'cv',
        title: 'Harea.Recruiting.Advert.Details.Menu.CurriculumVitaes.Label',
        element : <CvListContainer/>
    }
]